import styled from "@emotion/styled";

export const Container = styled.div`
  display: flex;
  padding: 0px 20px;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  gap: 20px;
`;

export const EmptyLow = styled.div`
  display: flex;
  min-width: 832px;
  align-items: flex-start;
  align-self: stretch;
  padding: 12px 24px;
  box-sizing: border-box;
  gap: 8px;
  align-items: center;
`;

export const BtnContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: end;
  align-self: stretch;
  gap: 8px;
`;
